import { createFileRoute } from "@tanstack/react-router";
import { DealAdmin } from "@/components/Deals/Admin";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  const dealId = params?.id as string;

  return <DealAdmin dealId={dealId} />;
}

export const Route = createFileRoute("/_authenticated/deals/$id/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
